import { useInternalLinks } from "@/lib/internalLinks";

/**
 * Related Services selector: choose approved pages to show in the page's
 * "Related Services" section. Order follows the order you tick them.
 */
export default function RelatedLinksPicker({ value, onChange, selfUrl, recommended, testid = "related-links" }) {
  const targets = useInternalLinks();
  const selected = value || [];
  const toggle = (url) =>
    onChange(selected.includes(url) ? selected.filter((u) => u !== url) : [...selected, url]);
  const options = targets.filter((t) => t.url !== selfUrl);

  return (
    <div data-testid={testid}>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="text-sm text-[#475569]">
          Shown as a <strong>Related Services</strong> section near the bottom of the page. Pages that aren’t published
          yet stay hidden until they are.
        </p>
        {recommended && recommended.length > 0 && (
          <button
            type="button"
            data-testid={`${testid}-use-recommended`}
            onClick={() => onChange(recommended.filter((u) => u !== selfUrl))}
            className="px-3 py-1.5 rounded-full border border-[#1E3A8A]/30 text-xs font-semibold text-[#1E3A8A] hover:bg-[#1E3A8A]/5"
          >
            Use recommended
          </button>
        )}
      </div>
      <div className="mt-3 grid sm:grid-cols-2 gap-2">
        {options.map((t) => (
          <label
            key={t.url}
            className={`flex items-center gap-2 rounded-xl border px-3 py-2 text-sm cursor-pointer ${
              selected.includes(t.url) ? "border-[#1E3A8A] bg-[#1E3A8A]/5" : "border-slate-200 bg-white"
            }`}
          >
            <input
              type="checkbox"
              data-testid={`${testid}-opt-${t.url.replace("/", "")}`}
              checked={selected.includes(t.url)}
              onChange={() => toggle(t.url)}
              className="w-4 h-4 accent-[#1E3A8A]"
            />
            <span className="font-medium text-[#0F172A]">{t.label}</span>
            <span className="text-xs text-slate-500">{t.url}</span>
            {!t.live && <span className="ml-auto text-[10px] font-semibold uppercase text-amber-700">Not published</span>}
          </label>
        ))}
      </div>
    </div>
  );
}
